import { ReactNode } from "react"
import "./Title.css"

interface TitleProps {
  title: ReactNode
  subtitle: string
  date?: string
  isProminent?: boolean
}

export default function Title({ date, title, subtitle, isProminent = false }: TitleProps) {
  return (
    <div className={`bf-promotions-title-wrapper `}>
      {date ? (
        <p
          className={`bf-promotions-title-date ${
            isProminent ? "bf-promotions-title-date-prominent" : null
          }`}
        >
          {date}
        </p>
      ) : null}
      <h2>{title}</h2>
      <p>{subtitle}</p>
    </div>
  )
}
